import {
	Home,
	Settings,
	UserX,
	FileStack,
	Package,
	Tags,
	FileEdit,
	Coins,
	Settings2,
	Building2,
	Calculator,
	Wallet,
	BellRing,
	MapPin,
	ShieldCheck,
	Users,
	Sliders,
	Crown,
	Database,
	FolderTree,
	Printer,
	ClipboardList,
} from "lucide-react";

export interface OrganizationMenuItem {
	title: string;
	icon: React.ReactNode;
	path: string;
	hasSubmenu?: boolean;
	submenuItems?: OrganizationSubmenuItem[];
}

export interface OrganizationSubmenuItem {
	title: string;
	path: string;
	icon: React.ReactNode;
}

export const ORGANIZATION_MENU_ITEMS: OrganizationMenuItem[] = [
	{
		title: "Übersicht",
		icon: <Home size={16} />,
		path: "/organisation",
	},
	{
		title: "Administration",
		icon: <Settings size={16} />,
		path: "/organisation/administration",
		hasSubmenu: true,
	},
	{
		title: "Leistungskatalog",
		icon: <FolderTree size={16} />,
		path: "/organisation/leistungskatalog",
	},
	{
		title: "Auftragsansichten",
		icon: <Settings2 size={16} />,
		path: "/organisation/auftragsansichten",
	},
	{
		title: "PDF-Gestaltung",
		icon: <FileEdit size={16} />,
		path: "/organisation/pdf-gestaltung",
	},
	{
		title: "Vorlagen/Jumbos",
		icon: <FileStack size={16} />,
		path: "/organisation/vorlagen-jumbos",
	},
	{
		title: "Tarifkataloge",
		icon: <Tags size={16} />,
		path: "/organisation/leistungen",
	},
	{
		title: "Artikel",
		icon: <Package size={16} />,
		path: "/organisation/artikel",
	},
];

export const ADMINISTRATION_MENU_ITEMS: OrganizationSubmenuItem[] = [
	{
		title: "Firmenangaben",
		path: "/organisation/administration/firmenangaben",
		icon: <Building2 size={16} />,
	},
	{
		title: "Rechnungswesen",
		path: "/organisation/administration/rechnungswesen",
		icon: <Calculator size={16} />,
	},
	{
		title: "Konten",
		path: "/organisation/administration/konten",
		icon: <Wallet size={16} />,
	},
	{
		title: "Mahnungswesen",
		path: "/organisation/administration/mahnungswesen",
		icon: <BellRing size={16} />,
	},
	{
		title: "Regionen",
		path: "/organisation/administration/regionen",
		icon: <MapPin size={16} />,
	},
	{
		title: "Garanten",
		path: "/organisation/administration/garanten",
		icon: <ShieldCheck size={16} />,
	},
	{
		title: "Benutzerverwaltung",
		path: "/organisation/administration/benutzerverwaltung",
		icon: <Users size={16} />,
	},
	{
		title: "Konfigurationseinstellungen",
		path: "/organisation/administration/konfigurationseinstellungen",
		icon: <Sliders size={16} />,
	},
	{
		title: "Abonnement",
		path: "/organisation/administration/abonnement",
		icon: <Crown size={16} />,
	},
	{
		title: "Datenbank Sicherung",
		path: "/organisation/administration/datenbank-sicherung",
		icon: <Database size={16} />,
	},
	{
		title: "Preislisten",
		path: "/organisation/administration/preislisten",
		icon: <Coins size={16} />,
	},
	{
		title: "Inaktive Kunden",
		path: "/organisation/administration/inaktive-kunden",
		icon: <UserX size={16} />,
	},
	{
		title: "Druckereinstellungen",
		path: "/organisation/administration/drucker",
		icon: <Printer size={16} />,
	},
	{
		title: "Druckeraufträge",
		path: "/organisation/administration/druckerauftraege",
		icon: <ClipboardList size={16} />,
	},
];
